import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import {
  WORKSPACE_LIMIT_EVENT,
  retryAfterWorkspaceLimit,
} from '@/lib/db/rxdb/utils/sharedWebSocketManager'

/**
 * Blocking dialog shown when moly-sync rejects the WebSocket because the user
 * has hit the concurrent-workspace cap. The fix is a user action (close another
 * tab), so we don't auto-retry — we wait for an explicit Retry click.
 */
export const WorkspaceLimitDialog = () => {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handler = () => setOpen(true)
    window.addEventListener(WORKSPACE_LIMIT_EVENT, handler)
    return () => window.removeEventListener(WORKSPACE_LIMIT_EVENT, handler)
  }, [])

  const onRetry = () => {
    setOpen(false)
    retryAfterWorkspaceLimit()
  }

  const onSignOut = () => {
    setOpen(false)
    window.location.href = '/auth'
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('workspaceLimit.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('workspaceLimit.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onSignOut}>{t('workspaceLimit.signOut')}</AlertDialogCancel>
          <AlertDialogAction onClick={onRetry}>{t('workspaceLimit.retry')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
